import HardwareOverview from "../../components/selfcare/HardwareOverview";
import HelpArticlesInternet from "../../components/selfcare/HelpArticlesInternet";
import ReportOffline from "../../components/selfcare/ReportOffline.tsx";
import NetworkOverview from "../../components/selfcare/NetworkOverview/NetworkOverview.tsx";
import {useCustomer} from "../../layouts/SelfcareLayout.tsx";

export default function InternetPage() {
    const {customer} = useCustomer()

    const filtered_laks_products = customer.product_instances
        .filter((product_instance) => (product_instance.can_see_network_overview))

    return <>
        {filtered_laks_products.length > 0 &&
            <>
                <NetworkOverview product_instances={filtered_laks_products}/>
                <hr/>
            </>
        }
        <ReportOffline/>
        <hr/>
        <HardwareOverview/>
        <HelpArticlesInternet/>
    </>
}
